<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <h2 class="mb-6 mt-0">
          Sourozenci (nepovinné)
        </h2>

        <v-btn
          @click="addCard('siblings')"
          class="mt-4 mb-4"
          color="blue lighten-1 white--text"
          depressed>
          Přidat sourozence
        </v-btn>

        <v-card
          v-for="(sibling, i) in siblings"
          :key="i + '-siblings'"
          class="pa-3"
          outlined>
          <v-row>
            <v-col
              cols="6">
              <VRadioWithValidation
                :rules="'required'"
                v-model="siblings[i].male"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Bratr"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Sestra"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              cols="6"
              class="text-right">
              <v-btn
                @click="removeCard(i, 'siblings')"
                class="ml-auto"
                color="indigo lighten-4"
                depressed>
                Odstranit
              </v-btn>
            </v-col>
            <v-col
              cols="2">
              <v-text-field
                v-model="siblings[i].yearBirth"
                label="Rok narození" />
            </v-col>
            <v-col
              cols="6">
              <v-row v-if="siblings[i].diseases.length">
                <v-col>
                  <v-chip
                    class="ma-2"
                    v-for="(sick, j) in siblings[i].diseases"
                    :key="j"
                    close
                    @click:close="removeCardChip(siblings[i], j)">
                    {{ sick.value }},
                    {{ sick.year }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row class="align-center">
                <v-col
                  class="pt-0"
                  cols="6">
                  <v-text-field
                    v-model="siblings[i].addingName"
                    label="Onemocnění" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="4">
                  <v-text-field
                    v-model="siblings[i].addingAge"
                    label="Věk diagnózy" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="2">
                  <v-btn fab
                         small
                         color="green darken-1 text--white"
                         @click="addSickCard(siblings[i])">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="2">
              <VRadioWithValidation
                :rules="'required'"
                v-model="siblings[i].alive"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Žije"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Nežije"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              v-if="siblings[i].alive === 1"
              cols="2">
              <v-text-field
                v-model="siblings[i].ageDeath"
                label="Věk úmrtí" />
            </v-col>
          </v-row>
        </v-card>

        <h2 class="mb-6 mt-12">
          Děti (nepovinné)
        </h2>

        <v-btn
          @click="addCard('children')"
          class="mt-4 mb-4"
          color="blue lighten-1 white--text"
          depressed>
          Přidat dítě
        </v-btn>

        <v-card
          v-for="(child, i) in children"
          :key="i + '-children'"
          class="pa-3"
          outlined>
          <v-row>
            <v-col
              cols="6">
              <VRadioWithValidation
                :rules="'required'"
                v-model="children[i].male"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Syn"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Dcera"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              cols="6"
              class="text-right">
              <v-btn
                @click="removeCard(i, 'children')"
                class="ml-auto"
                color="indigo lighten-4"
                depressed>
                Odstranit
              </v-btn>
            </v-col>
            <v-col
              cols="2">
              <v-text-field
                v-model="children[i].yearBirth"
                label="Rok narození" />
            </v-col>
            <v-col
              cols="6">
              <v-row v-if="children[i].diseases.length">
                <v-col>
                  <v-chip
                    class="ma-2"
                    v-for="(sick, j) in children[i].diseases"
                    :key="j"
                    close
                    @click:close="removeCardChip(children[i], j)">
                    {{ sick.value }},
                    {{ sick.year }}
                  </v-chip>
                </v-col>
              </v-row>
              <v-row class="align-center">
                <v-col
                  class="pt-0"
                  cols="6">
                  <v-text-field
                    v-model="children[i].addingName"
                    label="Onemocnění" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="4">
                  <v-text-field
                    v-model="children[i].addingAge"
                    label="Věk diagnózy" />
                </v-col>
                <v-col
                  class="pt-0"
                  cols="2">
                  <v-btn fab
                         small
                         color="green darken-1 text--white"
                         @click="addSickCard(children[i])">
                    <v-icon>add</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="2">
              <VRadioWithValidation
                :rules="'required'"
                v-model="children[i].alive"
                row
                custom-class="mt-2">
                <v-radio color="blue lighten-1"
                         label="Žije"
                         :value="true" />
                <v-radio color="blue lighten-1"
                         label="Nežije"
                         :value="1" />
              </VRadioWithValidation>
            </v-col>
            <v-col
              v-if="children[i].alive === 1"
              cols="2">
              <v-text-field
                v-model="children[i].ageDeath"
                label="Věk úmrtí" />
            </v-col>
          </v-row>
        </v-card>
        <v-col
          cols="auto">
          <v-btn @click="submit()"
                 type="submit"
                 x-large
                 depressed
                 height="68px"
                 class="px-12 white--text"
                 color="blue lighten-1">
            Uložit
          </v-btn>
        </v-col>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheKidsRelative',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      siblings: [],
      children: []
    };
  },
  methods: {
    addCard(type) {
      this[type].push({
        yearBirth: '',
        ageDeath: '',
        diseases: [],
        alive: null
      });
    },
    removeCard(i, type) {
      this[type].splice(i, 1);
    },
    addSickCard(obj) {
      if (!obj.addingAge || !obj.addingAge.length) {
        return;
      }
      obj.diseases.push({
        value: obj.addingName,
        year: obj.addingAge,
      });

      obj.addingName = '';
      obj.addingAge = '';
    },
    removeCardChip(obj, index) {
      obj.diseases.splice(index, 1);
    },
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formToSend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/siblingschildrenanamnesis', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  computed: {
    formToSend() {
      const siblings = JSON.parse(JSON.stringify(this.siblings));
      siblings.forEach((sibling) => {
        if (sibling.alive === 1) {
          sibling.alive = false;
        }
        if (sibling.male === 1) {
          sibling.male = false;
        }
      });
      const children = JSON.parse(JSON.stringify(this.children));
      children.forEach((child) => {
        if (child.alive === 1) {
          child.alive = false;
        }
        if (child.male === 1) {
          child.male = false;
        }
      });
      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        siblings,
        children,
      });
    }
  },
  created() {
    this.axios.get('admin/questionnaires/siblingschildrenanamnesis', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.siblings = data.siblings;
      this.siblings.forEach((sibling) => {
        if (sibling.alive === false) {
          sibling.alive = 1;
        }
        if (sibling.male === false) {
          sibling.male = 1;
        }
      });
      this.children = data.children;
      this.children.forEach((sibling) => {
        if (sibling.alive === false) {
          sibling.alive = 1;
        }
        if (sibling.male === false) {
          sibling.male = 1;
        }
      });
    });
  }
};
</script>
